var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GroupbuyingsList'
      }
    }
  }, [_vm._v("團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("門市庫存品開團")])], 1)], 1)])]), _c('b-card', [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-8 h5"
  }, [_vm._v("設定開團資料")]), _c('div', {
    staticClass: "col-4 h5"
  }, [_c('button', {
    staticClass: "btn btn-outline-danger",
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v(" 刪除 ")])]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', [_c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6",
    on: {
      "change": _vm.handleChangeProduct
    },
    model: {
      value: _vm.currentProductId,
      callback: function callback($$v) {
        _vm.currentProductId = $$v;
      },
      expression: "currentProductId"
    }
  }, [_vm.productOptions && _vm.productOptions.length > 1 ? _c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇商品名稱 ")]) : _vm._e(), _vm._l(_vm.productOptions, function (productOption) {
    return _c('b-form-select-option', {
      key: productOption.id,
      attrs: {
        "value": productOption.id
      }
    }, [_vm._v(" " + _vm._s(productOption.title) + " ")]);
  })], 2)], 1), _vm.isFetchProductInfo ? _c('b-spinner', {
    staticStyle: {
      "width": "2rem",
      "height": "2rem"
    },
    attrs: {
      "variant": "secondary"
    }
  }) : _vm._e(), _vm.showProductInfo ? _c('div', {
    staticClass: "mb-4 product-info"
  }, [_c('div', [_vm._v("店內碼: " + _vm._s(_vm.productInfo.barcode))]), _c('div', [_vm._v("國際碼: " + _vm._s(_vm.productInfo.ian))]), _c('div', [_vm._v("原價: " + _vm._s(_vm.productInfo.orig_price))]), _c('div', [_vm._v("售價: " + _vm._s(_vm.productInfo.sale_price))])]) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "7",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "庫存共",
      "label-for": "total_sku_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "total_sku_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.total_sku_quantity.$error ? false : null
    },
    on: {
      "click": _vm.handleSelect
    },
    model: {
      value: _vm.form.total_sku_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "total_sku_quantity", $$v);
      },
      expression: "form.total_sku_quantity"
    }
  }), _vm._v(" 件 "), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.total_sku_quantity.lengthSix.$invalid
    }
  }, [_vm._v(" 數字上限為六位數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "content-cols-xl": "7",
      "label-size": "sm",
      "label": "開團群組",
      "label-for": "input-1"
    }
  }, [true ? [_vm.isFetchGroup ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _vm._e(), _c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-1"
    },
    model: {
      value: _vm.form.group_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "group_ids", $$v);
      },
      expression: "form.group_ids"
    }
  }, _vm._l(_vm.groupOptions, function (group) {
    return _c('b-form-checkbox', {
      key: group.id,
      staticClass: "mb-lg-2 mb-0",
      attrs: {
        "value": group.id
      },
      on: {
        "change": function change($event) {
          return _vm.handleGroupOptionChange(group);
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12 col-lg-6 mb-2 mb-xl-0"
    }, [_vm._v(" " + _vm._s(group.name) + " ")]), _c('div', {
      staticClass: "col-lg-6 text-center"
    }, [_c('b-form-input', {
      staticClass: "mb-2 mr-sm-2 mb-sm-0",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "type": "number",
        "disabled": !_vm.form.group_ids.includes(group.id),
        "formatter": function formatter(value) {
          return value < 1 ? 0 : Math.round(value);
        },
        "state": _vm.v$.form.sku_quantities.$error && _vm.form.group_ids.includes(group.id) && group.sku_quantity > 999999 ? false : null
      },
      on: {
        "click": _vm.handleSelect,
        "change": _vm.handleGroupChange
      },
      model: {
        value: group.sku_quantity,
        callback: function callback($$v) {
          _vm.$set(group, "sku_quantity", $$v);
        },
        expression: "group.sku_quantity"
      }
    }), _vm._v(" 件 "), _vm.form.group_ids.includes(group.id) && group.sku_quantity > 999999 ? _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.form.sku_quantities.lengthSix.$invalid
      }
    }, [_vm._v(" 數字上限為六位數 ")]) : _vm._e()], 1)])]);
  }), 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.group_ids.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])] : [this.selectedGroup ? _c('div', [_vm._v(" " + _vm._s(this.selectedGroup.name) + " ")]) : _vm._e()]], 2), _c('b-form-group', {
    attrs: {
      "label-cols": "8",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "col-lg-2 mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.once_max_quantity.$error ? false : null
    },
    on: {
      "click": _vm.handleSelect
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    staticClass: "invalid-wording-right",
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於商品總數上限 ")]), _c('b-form-invalid-feedback', {
    staticClass: "invalid-wording-right",
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.lengthSix.$invalid
    }
  }, [_vm._v(" 數字上限為六位數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "8",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "col-lg-2 mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.once_quantity.$error ? false : null
    },
    on: {
      "click": _vm.handleSelect
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    staticClass: "invalid-wording-right",
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於每人最高購買數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "8",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "col-lg-2 mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.once_increase_quantity.$error ? false : null,
      "disabled": !_vm.canEditOnceIncreaseQuantity
    },
    on: {
      "click": _vm.handleSelect
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    staticClass: "invalid-wording-right",
    attrs: {
      "state": !_vm.v$.form.once_increase_quantity.less.$invalid
    }
  }, [_vm._v(" 下單遞增數與最低購買數加總不可大於最高購買數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間",
      "label-for": "input-1"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    staticClass: "mb-2",
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "date", $$v);
      },
      expression: "form.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.form.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "time", $$v);
      },
      expression: "form.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.time.HH.$error || !_vm.v$.form.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "截止時間",
      "label-for": "input-1",
      "description": "*達截止時間系統將自動結團"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    staticClass: "mb-2",
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": {
        'is-invalid': _vm.v$.form.start_at.$invalid
      },
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "date", $$v);
      },
      expression: "form.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 截止時間必須大於開團時間 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error || _vm.v$.form.start_at.date.beforeEndAt.$invalid
      }]
    },
    model: {
      value: _vm.form.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "time", $$v);
      },
      expression: "form.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.time.HH.$error || !_vm.v$.form.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工編號",
      "label-for": "tracking_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "id": "tracking_code",
      "formatter": function formatter(value) {
        return value.length > 6 ? value.slice(0, 6) : value;
      },
      "state": _vm.v$.form.tracking_code.$error ? false : null
    },
    model: {
      value: _vm.form.tracking_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tracking_code", $$v);
      },
      expression: "form.tracking_code"
    }
  }), _vm.v$.form.tracking_code.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e(), _vm.v$.form.tracking_code.lengthSix.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 需為6碼數字 ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序",
      "label-for": "order"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "id": "order",
      "state": _vm.v$.form.order.$error ? false : null
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  }), _vm.v$.form.order.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e(), _vm.v$.form.order.lengthTwo.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 需為2碼數字 ")]) : _vm._e()], 1)], 1)]), _c('div', {
    staticStyle: {
      "color": "#e06666",
      "padding": "20px 0px",
      "font-size": "14px"
    }
  }, [_vm._v("* 因 LINE 系統限制，請留意同期間開團數不得超過50個團購")]), _c('div', {
    staticClass: "d-flex justify-content-center buttons__action"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.saveAndBackToUpdateImages
    }
  }, [_vm._v(" 設定"), _c('br', {
    staticClass: "d-lg-none"
  }), _vm._v("商品圖片 ")]), _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.saveDraft
    }
  }, [_vm._v(" 儲存草稿 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 確認開團 ")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }